import { ValueLabel } from "@features/ax/shared/ValueLabel";
import { PageHeader } from "@shared/components/PageHeader";
import { Tooltip, TooltipContent, TooltipTrigger } from "@shared/ui/tooltip";
import { HelpCircle } from "lucide-react";

export const OverviewDetails = ({data}: {data: any}) => {
  const fields = [
    {
      label: "Read Cycle Name",
      value: `${data?.meterSchedule?.meterCycle?.meterCycleName || "NA"}`,
      tooltip: "Human-readable label to quickly identify this cycle.",
    },
    {
      label: "Month",
      value: `${data?.month || "NA"}`,
      tooltip: "Billing month associated with this cycle.",
    },
    {
      label: "Reading Period",
      value: `${data?.startDate || "NA"} - ${data?.endDate || "NA"}`,
      tooltip: "Run date window when readings are collected.",
    },
    { label: "Status", value: `${data?.status || "NA"}` },
  ];
  return (
    <div>
      <div className="flex justify-between items-center">
        <PageHeader
          title="Overview"
          subtitle="The performance metrics below correspond to the latest run of this read cycle."
        />
        <Tooltip>
          <TooltipTrigger>
            <HelpCircle className="h-4 w-4 text-gray-400" />
          </TooltipTrigger>
          <TooltipContent>
            <p className="max-w-xs">
              Track essential identifiers and timeline fields to orient KPI
              interpretation.
            </p>
          </TooltipContent>
        </Tooltip>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-4 lg:grid-cols-4 gap-4 mt-6">
        {fields.map((field, index) => (
          <ValueLabel
            label={field.label}
            value={field.value}
            tooltip={field.tooltip}
          />
        ))}
      </div>
      <p className="mt-6 text-xs text-gray-500">
        Note: All metrics below reflect the most recent reading period for this
        read cycle. Data aggregates all included routes.
      </p>
    </div>
  );
};
